import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/toaster';
import { Layout } from '@/components/layout';

// Pages
import Unidades from '@/pages/unidades';
import Documentos from '@/pages/documentos';
import Processos from '@/pages/processos';
import Pendencias from '@/pages/pendencias';
import Relatorio from '@/pages/relatorio';
import Auditoria from '@/pages/auditoria';
import AuditoriaV2 from '@/pages/auditoria-v2';
import RelatorioParaImpressao from '@/pages/relatorio/print';
import EditorRelatorio from '@/pages/relatorio/editor';

// Auth
import { AuthProvider, LoginPage, ProtectedRoute } from '@/features/auth';

// Admin
import {
  AdminAuthProvider,
  AdminLoginPage,
  AdminLayout,
  AdminEmailsPage,
  AdminHistoricoPage,
  AdminRegionalsPage,
  AdminMailerPage,
  AdminAccountsPage,
  AdminLogsPage,
  AdminSpreadsheetPage,
  AdminTaxSpreadsheetPage,
  AdminUnidadesOverridesPage,
  AdminLegalizacaoPage,
  AdminProtectedRoute,
  AdminInternalRoute,
} from '@/features/admin';

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="propertydocs-theme">
      <AuthProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Login Route */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected Main Dashboard Routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/unidades" replace />} />
                <Route path="unidades" element={<Unidades />} />
                <Route path="documentos" element={<Documentos />} />
                <Route path="processos" element={<Processos />} />
                <Route path="pendencias" element={<Pendencias />} />
                <Route path="relatorio" element={<Relatorio />} />
                <Route path="relatorio/print" element={<RelatorioParaImpressao />} />
                <Route path="relatorio/editor" element={<EditorRelatorio />} />
                <Route path="auditoria" element={<Auditoria />} />
                <Route path="v2" element={<AuditoriaV2 />} />
                <Route path="auditoria/v2" element={<Navigate to="/v2" replace />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route
                path="/admin/dashboard"
                element={
                  <AdminProtectedRoute>
                    <AdminLayout />
                  </AdminProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/admin/dashboard/emails" replace />} />
                <Route path="emails" element={<AdminEmailsPage />} />
                <Route path="mailer" element={<AdminMailerPage />} />
                <Route path="historico" element={<AdminHistoricoPage />} />
                <Route path="regionais" element={<AdminRegionalsPage />} />
                <Route path="planilha" element={<AdminSpreadsheetPage />} />
                <Route path="tributario" element={<AdminTaxSpreadsheetPage />} />
                <Route path="pdf-reports" element={<Navigate to="/admin/dashboard/emails" replace />} />
                <Route path="contas" element={<AdminAccountsPage />} />
                <Route path="logs" element={<AdminLogsPage />} />
                <Route path="overrides-unidades" element={<AdminUnidadesOverridesPage />} />
                <Route
                  path="legalizacao"
                  element={
                    <AdminInternalRoute>
                      <AdminLegalizacaoPage />
                    </AdminInternalRoute>
                  }
                />
              </Route>

              {/* Catch all - redirect to login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </AdminAuthProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
